import {
  AUTH_USER,
  UNAUTH_USER,
  AUTH_ERROR,
  START_AUTH,
} from '../actions';

const initialState = {
  isAuthenticated: false,
  isAuthenticating: false,
  user: {},
  error: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case START_AUTH:
      return {
        isAuthenticating: true,
      };
    case AUTH_USER:
      return {
        ...state,
        user: action.payload,
        error: '',
        isAuthenticated: true,
        isAuthenticating: false,
      };
    case UNAUTH_USER:
      return {
        ...state,
        error: '',
        isAuthenticated: false,
        user: {},
      };
    case AUTH_ERROR:
      return {
        ...state,
        isAuthenticating: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js